import {
  loadStripe,
  Stripe,
  StripeElementsOptions,
} from '@stripe/stripe-js';

import { Provider, PaymentMethodsType, StripeGatewayOptions } from '../../@types';
import { SupportedPaymentMethods } from '../../constants';

export interface ElementProps {
  options: StripeElementsOptions;
  stripe: Promise<Stripe | null>;
}

class StripeProvider implements Provider {
  static provider: Promise<Stripe | null>;

  private loadProvider(publishableKey: string, params?: StripeGatewayOptions) {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    if (!StripeProvider.provider) {
      StripeProvider.provider = loadStripe(publishableKey, {
        ...(params?.configurationOptions && { ...params?.configurationOptions }),
        ...(params?.betas && { betas: ['elements_enable_deferred_intent_beta_1'] }),
        // INFO: ...(params?.connectedAccount && { stripeAccount: params.connectedAccount }),
      });
    }
  }

  createProvider(params?: StripeGatewayOptions) {
    const { publishableKey } = params || {};
    if (!publishableKey) throw new Error('No publishable key error.');

    this.loadProvider(publishableKey, params);

    // TODO: should it be a part of params for loadProvider?
    // TODO: deprecated, remove
    const options: any = { ...params?.options };

    return {
      provider: StripeProvider.provider,
      // TODO: deprecated, remove
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getOptions: (method: PaymentMethodsType | PaymentMethodsType[]) => {
        switch (method) {
          case SupportedPaymentMethods.APPLEPAY:
            return {
              mode: 'payment',
              paymentMethodCreation: 'manual',
              amount: (+options.amount || 0) * 100,
              currency: options.currency || 'usd',
            };
          case SupportedPaymentMethods.GOOGLEPAY:
            return {
              mode: 'payment',
              paymentMethodCreation: 'manual',
              amount: (+options.amount || 0) * 100,
              currency: options.currency || 'usd',
            };
          default:
            // @ 'amount' is not applicable for most methods, so remove it if exists.
            // eslint-disable-next-line no-case-declarations
            const { amount, currency, ...other } = options;
            return { ...other };
        }
      },
    };
  }
}

const provider = new StripeProvider();

export { provider };
